import Enum from '@/modules/core/app/helpers/Enum';

export class TokenErrorCode extends Enum {
  static FIRST_ATTEMPT_FAILED_JOB = 'FIRST_ATTEMPT_FAILED_JOB';
  static FAILED_JOB = 'FAILED_JOB';
  static FORCED_RECONNECTION = 'FORCED_RECONNECTION';
  static SECURITY_QUESTION = 'SECURITY_QUESTION';

  static getReconnectErrorCodes(): string[] {
    return [
      TokenErrorCode.FAILED_JOB,
      TokenErrorCode.FORCED_RECONNECTION,
      TokenErrorCode.SECURITY_QUESTION
    ];
  }
}
